(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallDialogController', PhoneCallDialogController);

    /* Added $locale, $filter
    PhoneCallDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PhoneCall', 'CloudPBX', 'PhoneCallStatus', 'AdvertisingSource', 'Employee', 'OfficePhone', 'Division', 'User', 'PhoneCallCheck'];

    function PhoneCallDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PhoneCall, CloudPBX, PhoneCallStatus, AdvertisingSource, Employee, OfficePhone, Division, User, PhoneCallCheck) {
    */
    PhoneCallDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PhoneCall', 'CloudPBX', 'PhoneCallStatus', 'AdvertisingSource', 'Employee', 'OfficePhone', 'Division', 'User', 'PhoneCallCheck', '$locale', '$filter'];

    function PhoneCallDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PhoneCall, CloudPBX, PhoneCallStatus, AdvertisingSource, Employee, OfficePhone, Division, User, PhoneCallCheck, $locale, $filter) {
        var vm = this;

        vm.phoneCall = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.cloudpbxes = CloudPBX.query();
        vm.phonecallstatuses = PhoneCallStatus.query();
        /*
        vm.advertisingsources = AdvertisingSource.query();
        vm.employees = Employee.query();
        vm.officephones = OfficePhone.query();
        vm.divisions = Division.query();
        */
        vm.advertisingsources = AdvertisingSource.query({size: 9999, sort: 'name,asc', actual: false});
        vm.employees = Employee.query({size:9999, sort: 'fullname,asc', actual: false});
        vm.officephones = OfficePhone.query({size:9999, sort: 'title,asc', actual: false});
        vm.divisions = Division.query({size:9999, sort: 'title,asc', actual: false});
        vm.users = User.query();
        vm.phonecallchecks = PhoneCallCheck.query();
        vm.dateformat = $locale.DATETIME_FORMATS.medium;
        calcTitle();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.phoneCall.id !== null) {
                PhoneCall.update(vm.phoneCall, onSaveSuccess, onSaveError);
            } else {
                PhoneCall.save(vm.phoneCall, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:phoneCallUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.callTime = false;
        vm.datePickerOpenStatus.createTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function calcTitle() {
            var title = $filter('date')(vm.phoneCall.callTime, 'dd.MM.yy HH:mm') + " " + vm.phoneCall.callingCaption + " → " + vm.phoneCall.calledCaption;
            if (vm.phoneCall.calledEmployee != null) {
                title += " (" + vm.phoneCall.calledEmployee.division.name + ")";
            }
            vm.phoneCall.title = title;
        }
    }
})();
